// extracted by mini-css-extract-plugin
module.exports = {"hero":"terms_hero__UDQ2s","heroHeading":"terms_heroHeading__t2NVi","container":"terms_container__bfbuS"};